import React from 'react';
import { Box, Grid, TextField } from '@mui/material';

import { useZoneCategoryFormManager } from './zone-category-form.hook';

interface ZoneServiceItemsFormProps {
  categoryId?: number;
  onInit?: (loading: boolean) => void;
  onSubmitting?: (loading: boolean) => void;
  next?: (data?: any) => void;
}

export const ZoneCategoryForm = React.forwardRef(
  ({ categoryId, onInit = () => {}, onSubmitting = () => {}, next }: ZoneServiceItemsFormProps, ref) => {
    const [{ formManager, loading_form, loading_submit }] = useZoneCategoryFormManager({ categoryId, next });

    React.useImperativeHandle(ref, () => ({ onSubmit: () => formManager.handleSubmit() }), []);
    React.useEffect(() => onInit(loading_form), [loading_form]);
    React.useEffect(() => onSubmitting(loading_submit), [loading_submit]);

    return (
      <Box sx={{ paddingY: 2 }}>
        <form onSubmit={formManager.handleSubmit} autoComplete="off">
          <Grid container sx={{ alignItems: 'center' }} spacing={4}>
            <Grid item xs={12}>
              <TextField
                label="Zone Category Name"
                placeholder="Input category name..."
                variant="outlined"
                fullWidth
                value={formManager.values.category || ''}
                onChange={formManager.handleChange('category')}
                error={!!(formManager.errors.category && formManager.touched.category)}
                helperText={formManager.touched.category ? formManager.errors.category : null}
              />
            </Grid>
          </Grid>
        </form>
      </Box>
    );
  },
);
